export enum ApiPathEnum {
  Auth = '/auth',
  User = '/user',
  Player = '/player',
  UserLevel = '/user-level',
  Audit = '/audit',
  State = '/state',
  Bank = '/bank',
  AccountingAccount = '/accounting-account',
  AccountingCatalog = '/accounting-catalog',
  Country = '/country',
  Affiliate = '/affiliate',
  Module = '/module',
  Permission = '/permission',
  City = '/city',
  Province = '/province',
  GroupBankAccount = '/group-bank-account',
  HolderAccountHolder = '/holder-bank',
  Financial = '/financial',
  ChargesWithdrawalsRequest = '/charges-withdrawals-request',
  ChargesWithdrawals = '/charges-withdrawals',
  Closure = '/closure',
  SubscriptionPayment = '/subscription-payment',
  PageBalance = '/page-balance',
  CodeBonus = '/bonus-code',
  BalanceBonus = '/balance-bonus',
  HistoryBot = '/history-bot',
  BotVoucherChange = '/bot-voucher-change',
  Bot = '/bot',
  BotExtracts = '/bot-extracts',
  BotWithdrawal = '/bot-withdrawal',
  BotLiveVerification = '/bot-live-verification',
  Category = '/category',
  Roles = '/role',
  Payroll = '/payroll',
  PaymentPayroll = '/payment-payroll',
  CodePhone = '/cell-phone-code',
  Debt = '/debtlist',
  PermissionsRole = '/permissions-roles',
  ReportBank = '/report',
  DiaryAccountingDocs = '/diary',
  RRHHPermission = '/rrhhpermissions',
  RRHHPermissionType = '/rrhhpermissionstype',
  PromotionalMaterial = '/promotional-file',
  PromotionalMaterialFavorite = '/promotional-file-favorite',
  PromotionalMaterialCategory = '/promotional-file-category',
  PromotionalMaterialSport = '/promotional-file-sport',
  PredictionTemplate = '/template',
  PredictionQuestion = '/questions',
  AfiliateBettingResponses = '/responses',
  AfiliateBettingOptions = '/options',
  ReferralLink = '/referral-links',
  Placement = '/placement',
  AgentRequests = '/agent-requests',
  Feedback = '/feedback',
  FeedbackType = '/feedback-types',
  FeedbackStates = '/feedback-states',
  BankGroup = '/bank-group',
  BankAccountGroup = '/bank-account-group',
  ConfigAdmin = '/center-admin-config',
  SupportZgames = '/support-zgames',
  AuditConfigSource = '/audit-config-source',
  IvaBankConfig = '/iva-bank-config',
}

export enum AuthEndpointEnum {
  Login = '/signIn',
}
export enum AuthMobileEndpointEnum {
  Login = '/log-in/mobile',
}

export enum PromotionalMaterialEndpointEnum {
  GetPromotionalMaterial = '/get-all',
  CreatePromotionalMaterial = '/create-promotional-file',
  GetPromotionalMaterialById = '/get',
  UpdatePromotionalMaterial = '/update',
  DeletePromotionalMaterial = '/delete',
}

export enum PromotionalMaterialFavoriteEndpointEnum {
  MarkAsFavorite = '/mark',
  UnmarkAsFavorite = '/unmark',
  GetFavoritesByUser = '/get-user-favorites',
}

export enum PromotionalMaterialCategoryEndpointEnum {
  GetPromotionalMaterialCategory = '/get-all',
  CreatePromotionalMaterialCategory = '/create-category',
  GetPromotionalMaterialCategoryById = '/get',
  UpdatePromotionalMaterialCategory = '/update-category',
  DeletePromotionalMaterialCategory = '/delete-category',
}

export enum PromotionalMaterialSportEndpointEnum {
  GetPromotionalMaterialSport = '/get-all',
  CreatePromotionalMaterialSport = '/create-sport',
  GetPromotionalMaterialSportById = '/get',
  UpdatePromotionalMaterialSport = '/update-sport',
  DeletePromotionalMaterialSport = '/delete-sport',
}

export enum PlayerEndpointEnum {
  GetPlayersData = '/get-all',
  GetRegisteredPlayersByDate = '/get-registered-players-by-date',
  CreatePlayer = '/create',
  UpdatePlayer = '/update-player',
  DeactivatePlayer = '/delete-player',
  GetAllData = '/get-all-data',
}

export enum BotEndpointEnum {
  GetAllActionsData = '/get-all-actions',
  SaveAction = '/save',
}

export enum BotExtractsEndpointEnum {
  Grid = '/grid',
  ExecuteOne = '/execute-one',
  SendOtp = '/details',
  ExportBalanceSummary = '/export-balance-summary',
  Activity = '/activity',
  ResetCodeRequired = '/reset-code-required',
}

export enum AffiliateEndpointEnum {
  AffiliateInfoData = '/affiliate-info',
}
export enum ModuleEndpointEnum {
  GetAllModule = '/get-all',
  GetAllModulesWithPermissions = '/modules-permissions',
  CreateModule = '/create',
  UpdateModule = '/update',
  UpdateModuleStatus = '/update/:id/status',
}
export enum PermissionEndpointEnum {
  GetByPrincipalId = '/get-by-principal-id',
  CreatePermission = '/create',
  UpdatePermission = '/update',
  UpdatePermissionStatus = '/update/:id/status',
}
export enum RoleEndpointEnum {
  GetAllRoles = '/get-all',
  CreateRole = '/create',
  UpdateRole = '/update',
  UpdateRoleStatus = '/update/:id/status',
}

export enum PermissionsRoleEndpointEnum {
  GetAllPermissionsRole = '/get-all',
  CreatePermissionRole = '/create',
  UpdatePermissionsRole = '/update',
  DeletePermissionsRole = '/delete',
}

export enum ReportBankEndpointEnum {
  GetBankReport = '/get-bank-report',
}

export enum HistoryBotEndpointEnum {
  GetAllHistoryBotData = '/get-all',
  ValidateSuscriptionsPayments = '/validate-suscriptions-payments',
  GetRepeatedTransactionsByDateRange = '/repeated-transactions-by-date-range',
  SetState = '/set-change-status',
  ProcessReviewedRecords = '/process-reviewed-records',
  ProcessIvaTransactions = '/process-iva-transactions',
}

export enum BotVoucherChangeEndpointEnum {
  Requests = '/requests',
  PendingCount = '/requests/pending-count',
  Approve = '/requests/approve',
  Reject = '/requests/reject',
}

export enum HolderBankEndpointEnum {
  GetHoldersAccountBankData = '/get-all-holders',
  GetAllBankAccounts = '/get-all-bank-accounts',
  VerifyBankAccountEditAccess = '/verify-bank-account-edit-access',
}

export enum UserEndpointEnum {
  GetAllUser = '/get-all',
  GetAllAgents = '/get-all-agents',
  GetAllAgentsWithoutFilter = '/get-all-agents-without-filter',
  GetRrhhUsers = '/get-rrh-users',
  GetAllAgentNames = '/get-name-agent',
  GetAllAffiliates = '/get-all-affiliates',
  GetAllHolders = '/get-all-holders',
  GetUserById = '/get-user-by-id',
  GetUserByTokenApp = '/get-user-token-app',
  GetUserType = '/get-userlevel-by-id',
  GenerateTwoFactorData = '/generate-two-factor-data',
  ActivateTwoFactorAuth = '/activate-two-factor-auth',
  DesactivateTwoFactorAuth = '/desactivate-two-factor-auth',
  VerifyLogin = '/verify-login',
  UpdateProfile = '/update-user',
  ChangePassword = '/set-password',
  GetAuthorizeUsers = '/authorized',
  GetAgentId = '/agentId',
  GetDecisionsAuthorizedUsers = '/decisions',
  GetUsersByType = '/get-all-by-type',
  GetAllReferredAndAgents = '/get-all-referred-and-agents',
  GetAllCellPhoneCodes = '/get-all',
  ChangeDragStatus = '/change-drag-status',
}

export enum AuditEndpointEnum {
  GetAuditData = '/get-all',
  GetAuditDetail = '/get',
  GetAllScripts = '/get-all-scripts',
  GetAllActions = '/get-all-actions',
  GetAllTables = '/get-all-tables',
  getAllUsers = '/get-all-users',
  GetUserHistory = '/user-history',
}
export enum AuditConfigSourceEndpointEnum {
  GetAll = '/',
  GetAvailableTables = '/available-tables',
  GetUserTypes = '/user-types',
  Create = '/',
}
export enum DebtListEndpointEnum {
  GetDebtListData = '/get-all',
  CreateDebt = '/create',
  DesactivateDebt = '/delete-debt',
  GetFilteredStates = '/filtered-states',
  UpdateStatus = '/update-status',
}
export enum BalanceBonusEndpointEnum {
  CreateBalanceBonus = '/create',
  DownloadBalanceBonus = '/download-all-balances-bonus-data',
  GetBalanceBonusData = '/get-all',
  GetUserCreatedBonus = '/get-user-create-bonus',
  DesactivatedBonus = '/delete-balance-bonus',
}
export enum StateEndpointEnum {
  GetStateData = '/get-all',
  GetStateSpData = '/get-all-sp',
  GetStateLwData = '/get-all-lw',
}

export enum ChargesWithdrawalsRequestEnum {
  GetChargesWithdrawals = '/get-all',
  GetChargesWithdrawalsCounts = '/get-counts',
  CreateRequest = '/create',
  SetRequest = '/set-request',
  SetState = '/set-change-status',
  CreateReverse = '/set-request-reverse',
  CreateDivision = '/create-request-divide',
  GET_IMG_ENDPOINT = '/get-img',
  GET_CW = '/get-cw',
  GetPlayerTransactionsPerAgent = '/get-player-transactions-per-agent',
  GetRepeatedVouchersByDateRange = '/repeated-vouchers-by-date-range',
  getUserCreatedRequest = '/get-user-create-registier',
}

export enum ChargesWithdrawalsEnum {
  GetAllLw = '/get-all',
  GetUserEdiLw = '/get-user-edit-lw',
  DownloadLwData = '/download-all-lw-data',
  SetState = '/set-change-status',
  GetCategories = '/get-all',
  GetUsersForSelect = '/get-users-for-select',
  GetAllExternalData = '/get-all-external-data',
}
export enum ClosureEnum {
  ReportDaily = '/daily',
  ReportDailySpecific = '/daily-specific',
  GetNote = '/get-note',
  GetClosure = '/get-closure',
  SendClosure = '/send-closure',
  SendClosureZg = '/send-closure-zg',
  SendClosureBulkZg = '/send-closure-bulk-zg',
  SendClosureBulkApp = '/send-closure-bulk-app',
  SendClosureBulkDirect = '/send-closure-bulk-direct',
  SendClosureBulkZgEnhanced = '/send-closure-bulk-zg-enhanced',
  UpdateNote = '/update-note',
  CreateNote = '/create-note',
  GetAllClosureManagement = '/get-all-closure-management',
  GetClosureStats = '/get-closure-stats',
  CheckCacheStatus = '/check-cache-status',
  RefreshCache = '/refresh-cache',
}

export enum BankEndpointEnum {
  GetBankData = '/get-all',
  GetAllBanksBySelect = '/get-banks-select',
  CreateBank = '/create',
  UpdateBankState = '/update-status',
}

export enum PayrollEndPointEnum {
  GetAllPayrollData = '/get-all-payrolls',
  CreatePayroll = '/create',
  GetPayrollById = '/get-payroll',
  SendToFinancial = '/send-to-financial',
  UpdatePayroll = '/update-payroll',
  CheckPayrollExists = '/check-payroll-exists',
  GetDecimoConfig = '/decimo-config',
  UpdateDecimoConfig = '/decimo-config',
}

export enum PaymentPayrollEndPointEnum {
  GetPaymentPayrollData = '/get-all',
  CreatePaymentPayroll = '/create-payment-payroll',
  UpdatePaymentPayrollValues = '/update-payment-payroll-values',
}

export enum AccountingCatalogEndpointEnum {
  Companies = '/companies',
  CompaniesSelect = '/companies/select',
  Categories = '/categories',
  CategoriesSelect = '/categories/select',
  Accounts = '/accounts',
  AccountsSelect = '/accounts/select',
  AccountsSelectAll = '/accounts/select-all',
  AccountHierarchy = '/accounts/hierarchy',
}

export enum AccountingAccountEndpointEnum {
  GetAccountingAccountData = '/get-all',
  GetAllData = '/get-all-account',
  CreateAccount = '/create-account',
  UpdateAccount = '/update-account',
  AccountFilter = '/account-filter',
}

export enum CountryEndPointEnum {
  GetCountryData = '/get-all',
  GetCountryById = '/get-country',
  GetCountryDataByFilter = '/get-all-by-fliter',
}
export enum ProvincesEndPointEnum {
  GetProvincesData = '/get-all',
  GetProvincesById = '/get-province',
}
export enum CityEndPointEnum {
  GetCityData = '/get-all',
  GetCityById = '/get-city',
}
export enum GroupBankAccountEndPointEnum {
  GetGroupBankAccountData = '/get-all',
  GetGroupBankAccountById = '/get-group-bank-account',
}
export enum FinancialEndPointEnum {
  PostNewSpend = '/create',
  GetFinancial = '/movements',
  GetFinancialOne = '/movement',
  GetLastInvoice = '/last-invoice',
  GetLastSpent = '/last-spent',
  GetLastFlashMovement = '/last-flash-movement',
  DeleteFinancial = '/delete',
  UpdateFinancialStatus = '/movement/:id/status',
  DashboardSummary = '/dashboard/summary',
  DashboardMoneyFlow = '/dashboard/money-flow',
}

export enum SubscriptionPaymentEndpointEnum {
  GetFinancialMovementSummary = '/get-financial-movements-summary',
  GetIncomeAndExpenses = '/get-income-and-expenses',
  GetRepeatedVouchersByBankDateRange = '/repeated-vouchers-by-bank-date-range',
  GetBankAccounts = '/get-bank-accounts',
  GetAgentTransactionsSummary = '/get-agent-transactions-summary',
  GetExpensesByAccount = '/get-expenses-by-account',
  GetLatestExpenseMovements = '/latest-expenses-movements',
  GetAllSp = '/get-all',
  GetOneSp = '/get',
  GetUserEditSp = '/get-user-edit-sp',
  DownloadSpData = '/download-all-sp-data',
  SetState = '/set-change-status',
  updateItem = '/update-item',
}

export enum PageBalanceEndpointEnum {
  GetAllBalance = '/get-all-balance',
  CreateBalance = '/create-balance',
  UpdateBalance = '/update-balance',
  GetTotal = '/get-total',
  GetBalanceByDateAndAgent = '/get-balance-by-date-and-agent',
  GetLastsBalanceByDateAndAgent = '/get-lasts-balance-by-date-and-agent',
  CoverDetails = '/cover-details',
  GetStadistics = '/get-stadistics',
  StreamInsertAgentReports = '/stream-insert-agent-reports-monthly',
  GetStreamStatus = '/stream-status',
  GetOne = '/get-one-last-balance',
}

export enum CodeBonusEndpointEnum {
  GetAllBonusCode = '/get-all',
  UpdateStateBonusCode = '/update',
  GetAllTypeBonus = '/get-all-type-bonus',
  GetAllTypeBonusUnrestricted = '/get-all-type-bonus-unrestricted',
  GetAssignedTypeBonusByAgent = '/agent',
  CreateBonusCodes = '/create',
  GetAgentBalance = '/balance',
}
export enum UserMainEndpointEnum {
  GetAllAgentsByUsers = '/get-all-agents-by-users',
  GetAllHoldersByUsers = '/get-all-holders-by-users',
  GetAllAdministrativesByUsers = '/get-all-admin-by-users',
  GetAllAdministrativesByUsersSelect = '/get-all-admin-by-users-select',
  GetAllRoles = '/get-all',
  GetAllUsersByRole = '/get-all-users-select',
}
export enum DiaryAccountingDocEndpointsEnum {
  GetAllDiary = '/get-all',
  CreateDiary = '/create',
  UpdateDiary = '/update',
  DeleteDiary = '/delete',
}

export enum RRHHPermissionEndpointEnum {
  GetAllPermission = '/get-all-permission',
  CreatePermission = '/createPermission',
  UpdatePermission = '/updatePermission',
}

export enum RRHHPermissionTypeEndpointEnum {
  GetAllPermissionTypes = '/get-all-permission-types',
}

export enum PredictionsEndpointEnum {
  GetAllTemplates = '/get-all-templates',
  CreateTemplate = '/new-template',
  UpdateTemplate = '/update-template',
  GetAllQuestions = '/get-all-questions',
  CreateQuestions = '/new-questions',
  UpdateQuestion = '/update-question',
  CreateOption = '/new-options',
  UpdateOption = '/update-option',
  GetQuestionsByTemplate = '/get-questions-by-template',
}

export enum AfiliateBettingResponsesEndpointEnum {
  GetReport = '/report',
  GetAllOptions = '/get-all-options',
  GetResponsesByPlayer = '/player',
}

export enum ReferralLinkEndpointEnum {
  GetAllReferralLinks = '/get-all-referral-links',
  CreateReferralLink = '/new-referral-link',
  UpdateReferralLink = '/update-referral-link',
  GetReferralLinkById = '/get-referral-link',
  ToggleReferralLinkStatus = '/toggle-status',
  TrackReferralLinkVisit = '/track-visit',
  TrackReferralLinkRegister = '/track-register',
}

export enum PlacementEndpointEnum {
  CreatePlacement = '/new-placement',
  GetAllPlacements = '/get-all-placements',
  UpdatePlacement = '/update-placement',
  GetPlacementById = '/get-placement',
  DeletePlacement = '/delete-placement',
}

export enum AgentRequestEndpointEnum {
  GetAll = '/get-all-request',
  UpdateStatus = '/update-status',
  GetStatuses = '/get-statuses',
}

export enum FeedbackEndpointEnum {
  GetAllFeedback = '/get-all-feedback',
  GetOneFeedback = '/get-feedback',
  CreateFeedback = '/create-feedback',
  UpdateFeedback = '/update-feedback',
  DeleteFeedback = '/delete-feedback',
  GetAllAdministrativesByUsersSelect = '/get-all-admin-by-users-select',
}

export enum FeedbackTypeEndpointEnum {
  GetAllTypes = '/get-all-types',
}

export enum FeedbackStatesEndpointEnum {
  GetAllStates = '/get-all-states',
}

export enum BankGroupEndpointEnum {
  GetAll = '/get-all',
  GetForSelect = '/get-for-select',
  GetById = '/:id',
  Create = '/create',
  Update = '/:id',
  ChangeState = '/:id/change-state',
}

export enum BankAccountGroupEndpointEnum {
  GetMyAccounts = '/my-accounts',
  GetMyAccountByBank = '/my-accounts/bank/:bankId',
  GetAccountsByGroup = '/group/:groupId',
  GetUnassigned = '/unassigned',
  AssignToGroup = '/assign-to-group',
  RemoveFromGroup = '/:id_banco_titular/remove-from-group',
  ValidatePermission = '/:id_banco_titular/validate-permission',
}

export enum SupportZgamesEndpointEnum {
  GetCatalog = '/get-catalog',
  GetTickets = '/get-tickets',
  CreateTicket = '/create-ticket',
  UpdateTicket = '/update-ticket',
  GetTicketMessages = '/get-ticket-messages',
  AddTicketMessage = '/add-ticket-message',
  VariableOptions = '/variable-options',
  Preview = '/preview',
}

export enum IvaBankConfigEndpointEnum {
  GetAll = '/get-all',
  Create = '/create',
  Update = '/:id',
  Delete = '/:id',
}
